import { render, staticRenderFns } from "./AcademyForm.vue?vue&type=template&id=343ce93e&"
import script from "./AcademyForm.vue?vue&type=script&lang=js&"
export * from "./AcademyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports